import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
export type MessageActionsGroupFragment = { __typename?: 'MessageActionsGroup', createdAt: string, id: string, name: string, templateType?: Types.TemplateTypeEnum | null, updatedAt: string, actions: Array<{ __typename?: 'MessageAction', action: string, createdAt: string, description?: string | null, groupId: string, id: string, position: number, updatedAt: string, labels: { __typename?: 'LabelsCollection', cs?: string | null, da?: string | null, de?: string | null, en?: string | null, es?: string | null, fi?: string | null, fr?: string | null, it?: string | null, nb?: string | null, nl?: string | null, pl?: string | null, ptPt?: string | null, sv?: string | null, tr?: string | null } }> };

export const MessageActionsGroupFragmentDoc = gql`
    fragment messageActionsGroup on MessageActionsGroup {
  actions {
    action
    createdAt
    description
    groupId
    id
    labels {
      cs
      da
      de
      en
      es
      fi
      fr
      it
      nb
      nl
      pl
      ptPt
      sv
      tr
    }
    position
    updatedAt
  }
  createdAt
  id
  name
  templateType
  updatedAt
}
    `;